import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import ListItemGraphTestAssignment from "../common/ListItemGraphTestAssignment";
import ShortcutLink from "../common/ShortcutLink";
import {UserContext} from "../common/UserContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import {BrandContext} from "../common/BrandContext";
import ButtonSelect from "../common/ButtonSelect";
import Button from "../common/Button";

const TeacherGraphTestAssignmentsWidget = props => {
    const [classesProps, setClassesProps] = useState([]);
    const [classId, setClassId] = useState();
    const [testAssignments, setTestAssignments] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [testAssignmentState, setTestAssignmentState] = useState('ALL');
    const [testPurpose, setTestPurpose] = useState('ALL');
    const {user, setUser} = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const brandConfig = useContext(BrandContext);

    const testPurposes = [
        {value: 'ALL', label: 'All'},
        {value: 'TEST', label: 'Test'},
        {value: 'DIAGNOSTIC_TEST', label: 'Diagnostic'},
        {value: 'EXAM', label: 'Exam'}
    ];

    const testAssignmentStates = [
        {value: 'ALL', label: 'All'},
        {value: 'AVAILABLE', label: 'Assigned'},
        {value: 'NOT_ASSIGNED', label: 'Not assigned'},
        {value: 'ENDED', label: 'Ended'}
    ];

    useEffect(() => {
        const currentClass = user.classes.findIndex(clazz => clazz.classId == user.classId);
        let newClassesProps = {
            defaultSelected: currentClass == -1 ? 0 : currentClass,
            options: []
        };
        newClassesProps.options.push({value: 0, label: 'All'});
        user.classes.map(clazz => {
            let option = {
                value: clazz.classId,
                label: clazz.className
            }
            newClassesProps.options.push(option);
        });
        setClassesProps(newClassesProps);
    }, [user.classes]);

    useEffect(() => {
        setLoading(true);
        if (classId !== undefined) {
            axios.post('/web/ui/test/searchTeacherTestAssignments', {
                teacherId: user.userId,
                classId: classId,
                testPurpose: testPurpose === 'ALL' ? undefined : testPurpose,
                testAssignmentState: testAssignmentState === 'ALL' ? undefined : testAssignmentState
            })
                .then(response => {
                    setTestAssignments(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [classId, testPurpose, testAssignmentState]);

    const handleTestPurposeChange = selectedOption => {
        setTestPurpose(selectedOption.value);
    }

    const handleTestAssignmentStateChange = selectedOption => {
        setTestAssignmentState(selectedOption.value);
    }

    const handleClassChange = selectedOption => {
        setClassId(selectedOption.value);
    }

    const createTestFromDashBoard = () => {
        globalReactFunctions.createTestFromDashboard = true;
        loadShortcutByUrl('/web/ui/view/teacherAssessments');
    }

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#tests-icon"></use>
                    </svg>
                    <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/teacherAssessments'}>
                        <span>Tests Assignments</span>
                    </ShortcutLink>
                </div>
            }
            isLoading={isLoading}
            headerActions={
                <>
                    <Button size="small" onClick={createTestFromDashBoard}>Create a test</Button>
                    {(brandConfig.enableExams || brandConfig.enableDiagnosticTests) &&
                        <ButtonSelect title="Type" size="small" options={testPurposes} value={testPurpose !== undefined ? testPurposes.find(o => o.value === testPurpose) : 'ALL'} onChange={handleTestPurposeChange}/>
                    }
                    {user.brandCode != 'USA' &&
                        <ButtonSelect title="Status" size="small" options={testAssignmentStates}
                                      value={testAssignmentState !== undefined ? testAssignmentStates.find(o => o.value === testAssignmentState) : 'ALL'}
                                      onChange={handleTestAssignmentStateChange}/>
                    }
                    <ButtonSelect title="Class" size="small" options={classesProps.options} value={classesProps.defaultSelected !== undefined ? classesProps.options[classesProps.defaultSelected] : ''} onChange={handleClassChange}/>
                </>
            }
        >
            <div className={'ch-dashboard-blk-body'}>
                {testAssignments.length > 0 &&
                    testAssignments.map((testAssignment, index) => (
                        <ListItemGraphTestAssignment key={testAssignment.testAssignmentId} testAssignment={testAssignment} />
                    ))
                }
                {testAssignments.length == 0 &&
                    <div className="ch-list-item-disabled">No assigned tests</div>
                }
            </div>
            <div className={'ch-dashboard-blk-footer align-right'}>
                <Button type="text" onClick={() => loadShortcutByUrl("/web/ui/view/teacherAssessments")}>View</Button>
            </div>
        </DashboardWidget>
    )
}

export default TeacherGraphTestAssignmentsWidget;